<template>
  <ts-dialog :visible.sync="visible" title="Publication successfull" width="450px" center>
    <template #footer>
      <ts-button size="large" @click.prevent="visible = false"> Back to project </ts-button>
    </template>
      <div style="text-align: center; font-size: 1.1rem; line-height: 24px;">
        You can view it anytime on access.
      </div>
  </ts-dialog>
</template>

<script>
export default {
  name: 'AssetsPublishedToTheSourceDialog',
  data() {
    return {
      visible: false
    };
  },
  created() {
    window.EventBus.$on('Delivery.assets.published', () => {
      this.visible = true;
    });
  }
};
</script>

<style scoped lang="scss">
.container{
  display: flex;
}
</style>
